._LoaderWrapper_1jqha_1 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none; }
